import { render, staticRenderFns } from "./ProjectSettingsSideNav.vue?vue&type=template&id=361bbc03"
import script from "./ProjectSettingsSideNav.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsSideNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports